// @flow

import axios from "axios";
import {
  EXTERNAL_CONNECTION_ERRORS,
  GROUPS_WITH_EDITING_PRIVILEGES
} from "./constants";

const getAppRecords = async (appId: string, user: AppUser, source: string) => {
  try {
    const { id, group } = user;
    let userId = id;
    if (
      source === "all-users-files" &&
      GROUPS_WITH_EDITING_PRIVILEGES.indexOf(group) > -1
    ) {
      userId = "*";
    }
    const recordListRequest = await axios.get(
      `/api/shared/get-user/${userId}/records-for/${appId}`
    );
    const { data } = recordListRequest;
    return data;
  } catch (error) {
    console.error("Utils - Get application records - Error:", error);
    throw new Error(EXTERNAL_CONNECTION_ERRORS.GET_RECORDS);
  }
};

export default getAppRecords;
